import styled from 'styled-components';
import TextValue from '../../TariffCardNew/TextValue';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import StyledButton from '@ertelecom/ui-react/components/buttons/styledButton';
import Arrows from '~/static/images/icons/slider-arrows.svg';

const Content = styled.div`
    padding-left: 34px;
    padding-right: 34px;
    @media(max-width: 1366px) {
        padding-left: 20px;
        padding-right: 20px;
    }
    @media(max-width: 1024px) {
        padding-left: 34px;
        padding-right: 34px;
    }
    @media (max-width: 768px) {
        padding-left: 24px;
        padding-right: 24px;
    }
`;

export const PromoIcon = styled.div`
    position: absolute;
    top: 0;
    right: 30px;
    width: 32px;
    height: 32px;
    background: url(/static/images/icons/promo-tariff.svg) no-repeat center;
    @media(max-width: 1279px) {
        right: 11px;
    }
    @media (max-width: 530px) {
        right: 12px;
    }
`;

export const Head = styled(Content)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-top: ${p => p.compact ? '34px' : '10px'};
    padding-bottom: ${p => p.compact ? '8px' : '18px'};
    width: 100%;
    margin-bottom: ${p => p.compact ? '0' : '-8px'};
    background-color: ${({ headingColor, compact }) => compact ? COLORS.white : headingColor};
    color: ${({ headingColor, compact }) => compact ? headingColor : COLORS.white};
`;

export const Header = styled.div`
    display: block;
    width: 100%;
    white-space: normal;
`;

export const Title = styled.div`
    display: block;
    line-height: 1.33;
    font-family: ${FONTS.regular};
    font-size: ${p => p.compact ? '16px' : '20px'};
    @media(max-width: 1366px) {
        font-size: 16px;
    }
`;

export const Body = styled(Content)`
    display:block;
    background-color: ${COLORS.white};
    width: 100%;
`;

export const Description = styled.div`
    display: block;
    width: 100%;
    padding: ${p => p.compact ? '0' : '20px 0'};;
    font-family: ${FONTS.light};
    color: ${COLORS.black};
    line-height: 1.33;
    white-space: normal;
    flex-wrap: wrap;
    font-size: ${p => p.compact ? '16px' : '20px'};
    @media(max-width: 1366px) {
        font-size: 16px;
    }
`;

export const Options = styled.div`
    display:flex;
    width: 100%;
    padding: 15px 0;
    flex-direction: column;
`;

export const Tuning = styled.div``;

export const ButtonBlock = styled.div`
    padding: 12px 0 24px;
    text-align: center;
`;

export const Button = styled(StyledButton)`
    width: 100%;
    padding: 10px 15px;
    margin-bottom: 8px;
    font-size: 14px;
    @media (min-width: 1024px) and (max-width: 1279px) {
        padding: 10px;
    }
`;

export const SimpleDetailLink = styled.a`
    :hover {
        color: ${COLORS.red};
    }
`;
export const DetailizationLink = styled.a`
    padding: 8px 0;
    width: 100%;
    font-size: 14px;
    color: ${COLORS.darkGrey};
    text-decoration: underline;
    cursor: pointer;
    :hover {
        color: ${COLORS.red};
    }
`;

export const PriceBlock = styled.div`
    display:block;
`;

export const Price = styled(TextValue)`
    margin-top: 0;
`;

export const Counter = styled.p`
    display: none;
    margin-top: 10px;
    font-family: ${FONTS.light}, Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    color: #979797;
    margin-right: 17px;
    line-height: 24px;
    text-align: center;
    @media(max-width:1024px){
        display:none;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    align-self: center;
    background-color: ${ props => props.bgColor ? props.bgColor : '#333333'};
`;

export const DotWrapper = styled.div`
    align-self: center;
    margin: 0 auto -46px 20px;

`;

export const Dots = styled.div`
    width: 11px;
    height: 11px;
    border-radius: 50%;
    text-align: center;
    background: ${props => props.active ? '#6da4ff' : '#cecece'};
    opacity: ${props => props.active ? 1 : 0.6};
    margin: 0px;
    padding: 5px;
    margin-right: 20px;
    cursor: pointer;
    @media(min-width:1025px){
        display:none;
    }
    &:hover{
        opacity: ${props => props.active ? 1 : 0.6};
        background: #6da4ff;
    }

`;

export const ArrowWrapper = styled.div`
    width: calc(100% + 60px);
    display: flex;
    justify-content: space-between;
    position: absolute;
    top: calc(50% - 15px);
    left: -30px;
    @media(max-width: 1024px) {
        display: none;
    }
`;

export const LeftArrow = styled.div`
    :before {
    display: flex;
    content:''!important;
    width: 21px;
    height: 36px;
    left: -7px;
    opacity: 1;
    background-image: url(${Arrows})!important;
    background-repeat: no-repeat;
    background-position: 0;
    }
`;

export const RightArrow = styled.div`
    :before {
    display: flex;
    content:''!important;
    margin-left:10px;
    width: 21px;
    height: 36px;
    left: 7px;
    opacity: 1;
    background-image: url(${Arrows})!important;
    background-repeat: no-repeat;
    background-position: -25px;
   }
`;

export const SliderWrapper = styled.div`
    overflow: visible;
    width: calc(100% + 20px);
    margin: 0 -10px;
    @media(max-width: 1279px) {
        margin: 0 -5px;
        width: calc(100% + 10px);
    }
    @media(max-width: 767px) {
        max-width: 370px;
        margin-bottom: 48px;
    }
`;

export const Slide = styled.div`
    display: block;
    width: calc(100% - 20px);
    margin: 0 auto;
    max-width: 431px;
    @media(max-width: 1279px) {
        width: calc(100% - 10px);
    }
`;

export const PaddingWrapper = styled(Wrapper)`
    padding-top: ${p => p.nonTopPadding ? '0' : '120px'};
    padding-bottom: ${p => p.nonBottomPadding ? '0' : '60px'};
    overflow: hidden;
    @media(max-width: 767px) {
        padding-bottom: 40px;
    }
`;

export const ActionText = styled.div`
    margin-top: 35px;
    font-family: ${FONTS.light};
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;    
    color: ${COLORS.darkGrey};
    @media(max-width: 860px) {
        font-size: 12px;
    }
`;

export const HiddenBlock = styled.div`
    position: absolute;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
`;

export const PopupTitle = styled.h3`
    font-family: ${FONTS.regular};
    font-size: 32px;
    line-height: 40px;
    color: ${COLORS.black};
`;

export const PopupSupTitle = styled.p`
    font-family: ${FONTS.light};
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.darkGrey};
    margin-top: 4px;
`;

export const ArchiveList = styled.div`
    justify-content: space-between;
    margin-top: 20px;
    @media(max-width: 767px) {
        flex-direction: column;
    }
`;

export const ArchiveListTitle = styled.p`
    font-family: ${FONTS.regular};
    color: ${COLORS.black};
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 28px;
`;

export const ArchiveListItem = styled.div`
    width: 45%;
    @media(max-width: 767px) {
        width: 100%;
        margin-bottom: 20px;
    }
`;

export const ArchiveLine = styled.div`
    width: 2px;
    height: auto;
    border: 1px solid ${COLORS.outlineGrey};
    @media(max-width: 767px) {
        display: none;
    }
`;
